module.exports = __webpack_public_path__ + "static/slaughterhouse-5-07db4392b1d97394d6fa98c64e86d534.jpg";